export class AppFilters {
    constructor(typeOptions) {
        this.statusOptions = [
            { label: 'Vencido', value: '4' },
            { label: 'Próximo a vencer', value: '3' },
            { label: 'Pendiente', value: '2' },
            { label: 'Saldo a favor', value: '1' },
        ];
        this.dateOptions = [];
        this.typeOptions = [];
        this.tags = [];
        this.typeOptions = typeOptions;
        this.term = '';
        this.date = '';
        this.status = '';
        this.type = '';
    }
    setTerm(term) {
        this.term = term;
        this.updateTags({
            variable: 'term',
            label: term,
            value: term
        });
    }
    setDate(date) {
        this.date = date;
        this.updateTags({
            variable: 'date',
            label: date,
            value: date
        });
    }
    setStatus(status, label) {
        this.status = status;
        this.updateTags({
            variable: 'status',
            label: label,
            value: status
        });
    }
    setType(type, label) {
        this.type = type;
        this.updateTags({
            variable: 'type',
            label: label,
            value: type
        });
    }
    updateTags(tag) {
        const index = this.tags.findIndex(t => t.variable === tag.variable);
        if (index > -1) {
            if (!tag.value) {
                this.tags.splice(index, 1);
            }
            else {
                this.tags[index] = tag;
            }
        }
        else if (tag.value) {
            this.tags.push(tag);
        }
    }
    clear(variable) {
        this[variable] = '';
        this.updateTags({
            variable: variable,
            label: '',
            value: ''
        });
    }
    clearAll() {
        this.term = '';
        this.type = '';
        this.status = '';
        this.date = '';
        this.tags = [];
    }
    get filterParams() {
        const filters = {
            term: this.term, date: this.date, type: this.type, status: this.status
        };
        for (const key of Object.keys(filters)) {
            if (!this[key]) {
                delete filters[key];
            }
        }
        if (Object.keys(filters).length < 1) {
            return null;
        }
        return filters;
    }
}
